import { render, staticRenderFns } from "./ProjectTaskCommentCreatedNotification.vue?vue&type=template&id=7ccf44a4"
import script from "./ProjectTaskCommentCreatedNotification.vue?vue&type=script&lang=js"
export * from "./ProjectTaskCommentCreatedNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports